import React, { useState } from "react";
import { Layers, Menu } from "lucide-react";

// categories: array of { id, name } objects
// selected: the id of the selected category ('all' for Semua Kategori)
// orientation: 'horizontal' | 'vertical' (default: 'horizontal')
export default function CategoryFilter({
  categories = [],
  selected = "all",
  onSelect,
  rightContent,
  orientation = "horizontal",
}) {
  const [isCollapsed, setIsCollapsed] = useState(false);

  if (orientation === "vertical") {
    if (isCollapsed) {
      return (
        <div className="bg-white rounded-2xl ring-1 ring-slate-200/70 p-2 shadow-sm flex flex-col h-full overflow-hidden w-12 sm:w-14 shrink-0 transition-all duration-300 items-center">
          {/* Tombol Buka Kategori */}
          <button
            type="button"
            onClick={() => setIsCollapsed(false)}
            className="p-2 text-slate-500 hover:text-teal-700 hover:bg-slate-100 rounded-xl transition-colors mb-2 cursor-pointer"
            title="Buka Daftar Kategori">
            <Menu className="w-4 h-4" />
          </button>

          {/* Daftar Kategori Mini (Icon / Initials) */}
          <div className="flex-1 overflow-y-auto space-y-1.5 no-scrollbar w-full flex flex-col items-center">
            {categories.map((cat) => {
              const isActive = selected === cat.id;
              const shortLabel =
                cat.id === "all"
                  ? "All"
                  : cat.id === "best_seller"
                    ? "★"
                    : cat.name.slice(0, 2).toUpperCase();

              return (
                <button
                  key={cat.id}
                  type="button"
                  onClick={() => onSelect(cat)}
                  title={cat.name}
                  className={`w-9 h-9 sm:w-10 sm:h-10 rounded-xl text-[11px] font-bold transition-all flex items-center justify-center shrink-0 cursor-pointer ${
                    isActive
                      ? "bg-gradient-to-br from-teal-600 to-emerald-600 text-white shadow-md shadow-teal-600/25 ring-1 ring-teal-500"
                      : "bg-slate-50 text-slate-600 hover:bg-teal-50 hover:text-teal-700 border border-slate-100"
                  }`}>
                  <span>{shortLabel}</span>
                </button>
              );
            })}
          </div>
        </div>
      );
    }

    return (
      <div className="bg-white rounded-2xl ring-1 ring-slate-200/70 shadow-sm flex flex-col h-full overflow-hidden w-44 sm:w-48 lg:w-52 shrink-0 transition-all duration-300">
        {/* Header Kategori Samping dengan Tombol Lipat (Collapse) */}
        <div className="flex items-center justify-between px-3.5 py-3 border-b border-slate-100 shrink-0">
          <div className="flex items-center gap-1.5 text-slate-800">
            <Layers className="w-4 h-4 text-teal-600 shrink-0" />
            <span className="text-xs font-bold uppercase tracking-wider">Kategori Produk</span>
          </div>
          <button
            type="button"
            onClick={() => setIsCollapsed(true)}
            className="p-1 text-slate-400 hover:text-teal-700 hover:bg-slate-100 rounded-lg transition-colors cursor-pointer"
            title="Lipat Kategori">
            <Menu className="w-4 h-4" />
          </button>
        </div>

        {/* Daftar Kategori Vertikal (Scrollable) */}
        <div className="flex-1 overflow-y-auto divide-y divide-slate-100 no-scrollbar">
          {categories.map((cat) => {
            const isActive = selected === cat.id;
            return (
              <button
                key={cat.id}
                type="button"
                onClick={() => onSelect(cat)}
                className={`w-full text-left px-3.5 py-3 text-xs sm:text-sm transition-all flex items-center justify-between border-l-4 cursor-pointer ${
                  isActive
                    ? "bg-teal-50/80 text-teal-900 font-bold border-teal-600"
                    : "text-slate-700 hover:bg-slate-50 font-medium border-transparent"
                }`}>
                <span className="truncate">{cat.name}</span>
                {isActive && (
                  <span className="w-1.5 h-1.5 rounded-full bg-teal-600 shrink-0 ml-1" />
                )}
              </button>
            );
          })}
        </div>
      </div>
    );
  }

  // Default: Horizontal Bar
  return (
    <div className="bg-white rounded-2xl ring-1 ring-slate-200/70 p-3 shadow-sm flex items-center justify-between gap-4">
      <div className="overflow-x-auto no-scrollbar -mx-1 px-1 flex-1">
        <div className="flex items-center min-w-max gap-2">
          {categories.map((cat) => {
            const isActive = selected === cat.id;
            return (
              <button
                key={cat.id}
                type="button"
                onClick={() => onSelect(cat)}
                className={`relative inline-flex items-center px-4 py-2.5 rounded-xl text-sm font-medium whitespace-nowrap transition-all ${
                  isActive
                    ? "bg-gradient-to-br from-teal-600 to-emerald-600 text-white shadow-md shadow-teal-600/30 ring-1 ring-teal-500"
                    : "bg-slate-50 text-slate-600 ring-1 ring-transparent hover:text-teal-700 hover:bg-teal-50 hover:ring-teal-200"
                }`}>
                {cat.name}
              </button>
            );
          })}
        </div>
      </div>
      {rightContent && (
        <div className="flex items-center shrink-0 border-l border-slate-100 pl-4">
          {rightContent}
        </div>
      )}
    </div>
  );
}
